(function () {
  'use strict';

  /* =========================================================
     DYENOTE S.S.S. V4
     - Türkçe karakter destekli arama
     - Kategori alias sistemi
     - Eski/yeni data-category değerleriyle uyumlu
     - Shopify uyumlu
  ========================================================= */

  function normalizeText(value) {
    if (!value) return '';

    return String(value)
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&amp;/g, ' ')
      .replace(/&/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }


  /* =========================================================
     KATEGORİ ANAHTARINI STANDARTLAŞTIR
  ========================================================= */

  function canonicalCategory(value) {
    var text = normalizeText(value);

    if (!text) {
      return '';
    }

    /* TÜMÜ */
    if (
      text === 'all' ||
      text === 'tum' ||
      text === 'tumu' ||
      text === 'hepsi'
    ) {
      return 'all';
    }


    /* UV-DTF önce kontrol edilmeli.
       Aksi halde içindeki DTF nedeniyle DTF kategorisine düşebilir. */
    if (
      text === 'uvdtf' ||
      text === 'uv-dtf' ||
      text === 'uv dtf' ||
      text === 'uv-dtf etiket' ||
      text === 'uv dtf etiket' ||
      text === 'uvdtf etiket'
    ) {
      return 'uvdtf';
    }


    /* DTF */
    if (
      text === 'dtf' ||
      text === 'dtf tekstil' ||
      text === 'dtf tekstil baski' ||
      text === 'tekstil dtf'
    ) {
      return 'dtf';
    }


    /* STICKER */
    if (
      text === 'sticker' ||
      text === 'etiket' ||
      text === 'sticker etiket' ||
      text === 'sticker ve etiket' ||
      text === 'sticker & etiket'
    ) {
      return 'sticker';
    }


    /* BASKILI TEKSTİL */
    if (
      text === 'textile' ||
      text === 'textil' ||
      text === 'baskili tekstil' ||
      text === 'baskili textile'
    ) {
      return 'textile';
    }


    /* PROMOSYON */
    if (
      text === 'promo' ||
      text === 'promosyon' ||
      text === 'promosyon urunleri' ||
      text === 'promotion'
    ) {
      return 'promo';
    }


    /* MATBAA */
    if (
      text === 'print' ||
      text === 'matbaa' ||
      text === 'matbaa urunleri' ||
      text === 'printing'
    ) {
      return 'print';
    }


    /* GENİŞ FORMAT */
    if (
      text === 'wide' ||
      text === 'wide format' ||
      text === 'genis format' ||
      text === 'genis format baski'
    ) {
      return 'wide';
    }


    /* DOSYA & SİPARİŞ */
    if (
      text === 'file' ||
      text === 'files' ||
      text === 'dosya' ||
      text === 'siparis' ||
      text === 'dosya siparis' ||
      text === 'dosya ve siparis' ||
      text === 'dosya & siparis'
    ) {
      return 'file';
    }


    /* KURUMSAL & FASON */
    if (
      text === 'corporate' ||
      text === 'kurumsal' ||
      text === 'fason' ||
      text === 'kurumsal fason' ||
      text === 'kurumsal ve fason' ||
      text === 'kurumsal & fason'
    ) {
      return 'corporate';
    }


    return text;
  }


  /* =========================================================
     BUTONUN KATEGORİSİNİ BUL
  ========================================================= */

  function getButtonCategory(button) {
    if (!button) {
      return 'all';
    }

    var dataFilter =
      button.getAttribute('data-filter');

    if (dataFilter) {
      var direct =
        canonicalCategory(dataFilter);

      if (direct) {
        return direct;
      }
    }

    return canonicalCategory(
      button.textContent
    ) || 'all';
  }


  /* =========================================================
     FAQ ITEM KATEGORİLERİNİ BUL

     Farklı yazım biçimlerini destekliyoruz:
     data-category="promo"
     data-category="promosyon"
     data-category="promo corporate"
     data-category="promosyon,kurumsal"
     data-category="BASKILI TEKSTİL"
  ========================================================= */

  function getItemCategories(item) {
    var raw =
      item.getAttribute('data-category') || '';

    var normalized =
      normalizeText(raw);

    var found = [];


    function add(category) {
      if (
        category &&
        found.indexOf(category) === -1
      ) {
        found.push(category);
      }
    }


    /*
      Önce boşluk, virgül, noktalı virgül,
      slash veya pipe ile ayrılmış değerleri tara.
    */

    var parts =
      raw.split(/[,;|/]+/);

    parts.forEach(function (part) {
      var direct =
        canonicalCategory(part);

      if (
        direct &&
        direct !== normalizeText(part)
      ) {
        add(direct);
      }
    });


    /*
      Tek kelimelik mevcut sistem:
      "promo corporate"
      "textile dtf"
    */

    raw.split(/\s+/).forEach(
      function (part) {

        var category =
          canonicalCategory(part);

        if (
          category === 'dtf' ||
          category === 'uvdtf' ||
          category === 'sticker' ||
          category === 'textile' ||
          category === 'promo' ||
          category === 'print' ||
          category === 'wide' ||
          category === 'file' ||
          category === 'corporate'
        ) {
          add(category);
        }
      }
    );


    /*
      İnsan tarafından yazılmış uzun
      kategori isimlerini de tespit et.
    */

    if (
      normalized.indexOf('uv-dtf') !== -1 ||
      normalized.indexOf('uv dtf') !== -1 ||
      normalized.indexOf('uvdtf') !== -1
    ) {
      add('uvdtf');
    }


    /*
      UV-DTF olmayan normal DTF.
    */
    if (
      (
        normalized === 'dtf' ||
        normalized.indexOf(
          'dtf tekstil'
        ) !== -1
      ) &&
      normalized.indexOf('uv') === -1
    ) {
      add('dtf');
    }


    if (
      normalized.indexOf(
        'baskili tekstil'
      ) !== -1 ||
      normalized === 'textile'
    ) {
      add('textile');
    }


    if (
      normalized.indexOf('sticker') !== -1 ||
      (
        normalized.indexOf('etiket') !== -1 &&
        normalized.indexOf('uv') === -1
      )
    ) {
      add('sticker');
    }


    if (
      normalized.indexOf('promosyon') !== -1 ||
      normalized.indexOf('promo') !== -1
    ) {
      add('promo');
    }


    if (
      normalized.indexOf('matbaa') !== -1 ||
      normalized === 'print'
    ) {
      add('print');
    }


    if (
      normalized.indexOf(
        'genis format'
      ) !== -1 ||
      normalized === 'wide'
    ) {
      add('wide');
    }


    if (
      normalized.indexOf('dosya') !== -1 ||
      normalized.indexOf('siparis') !== -1 ||
      normalized === 'file'
    ) {
      add('file');
    }


    if (
      normalized.indexOf('kurumsal') !== -1 ||
      normalized.indexOf('fason') !== -1 ||
      normalized === 'corporate'
    ) {
      add('corporate');
    }


    return found;
  }


  /* =========================================================
     DATA-CATEGORY YOKSA YEDEK SINIFLANDIRMA

     Shopify HTML'i data-category kısmını değiştirmiş veya
     kaldırmış olsa bile soru metninden kategori tahmini yapar.
  ========================================================= */

  function inferCategoryFromContent(item) {
    var text =
      normalizeText(item.textContent);

    var result = [];


    function add(category) {
      if (
        result.indexOf(category) === -1
      ) {
        result.push(category);
      }
    }


    /* UV-DTF */
    if (
      text.indexOf('uv-dtf') !== -1 ||
      text.indexOf('uv dtf') !== -1 ||
      text.indexOf('uvdtf') !== -1
    ) {
      add('uvdtf');
    }


    /* DTF */
    if (
      text.indexOf('dtf') !== -1 &&
      text.indexOf('uv-dtf') === -1 &&
      text.indexOf('uv dtf') === -1 &&
      text.indexOf('uvdtf') === -1
    ) {
      add('dtf');
    }


    /* PROMOSYON */
    if (
      text.indexOf('promosyon') !== -1 ||
      text.indexOf('kupa') !== -1 ||
      text.indexOf('bardak') !== -1 ||
      text.indexOf('anahtarlik') !== -1 ||
      text.indexOf('kalem') !== -1
    ) {
      add('promo');
    }


    /* MATBAA */
    if (
      text.indexOf('kartvizit') !== -1 ||
      text.indexOf('brosur') !== -1 ||
      text.indexOf('el ilani') !== -1 ||
      text.indexOf('matbaa') !== -1 ||
      text.indexOf('afis') !== -1
    ) {
      add('print');
    }


    /* GENİŞ FORMAT */
    if (
      text.indexOf('branda') !== -1 ||
      text.indexOf('rasel') !== -1 ||
      text.indexOf('kanvas') !== -1 ||
      text.indexOf('genis format') !== -1 ||
      text.indexOf('folyo baski') !== -1
    ) {
      add('wide');
    }


    /* STICKER */
    if (
      text.indexOf('sticker') !== -1 ||
      text.indexOf('opak etiket') !== -1 ||
      text.indexOf('seffaf etiket') !== -1 ||
      text.indexOf('reflektif') !== -1 ||
      text.indexOf('baskes') !== -1 ||
      text.indexOf('ozel kesim') !== -1
    ) {
      add('sticker');
    }


    /* BASKILI TEKSTİL */
    if (
      text.indexOf('tisort') !== -1 ||
      text.indexOf('sweatshirt') !== -1 ||
      text.indexOf('hoodie') !== -1 ||
      text.indexOf('is kiyafeti') !== -1 ||
      text.indexOf('forma') !== -1 ||
      text.indexOf('spor tekstil') !== -1 ||
      text.indexOf('sapka') !== -1
    ) {
      add('textile');
    }


    /* DOSYA / SİPARİŞ */
    if (
      text.indexOf('dosya') !== -1 ||
      text.indexOf('dpi') !== -1 ||
      text.indexOf('canva') !== -1 ||
      text.indexOf('cmyk') !== -1 ||
      text.indexOf('rgb') !== -1 ||
      text.indexOf('font') !== -1 ||
      text.indexOf('outline') !== -1 ||
      text.indexOf('siparis') !== -1 ||
      text.indexOf('kargo') !== -1
    ) {
      add('file');
    }


    /* KURUMSAL */
    if (
      text.indexOf('kurumsal') !== -1 ||
      text.indexOf('fason') !== -1 ||
      text.indexOf('toplu siparis') !== -1 ||
      text.indexOf('numune') !== -1
    ) {
      add('corporate');
    }


    return result;
  }


  /* =========================================================
     BAŞLAT
  ========================================================= */

  function initDyenoteFAQ() {
    var app =
      document.getElementById(
        'dyenoteFaqApp'
      );

    if (!app) {
      return;
    }


    /*
      Önceki sürüm attribute'larından bağımsız
      yeni bir versiyon anahtarı kullanıyoruz.
    */

    if (
      app.getAttribute(
        'data-dyenote-faq-v4'
      ) === 'ready'
    ) {
      return;
    }


    var searchInput =
      app.querySelector('#dyFaqSearch');

    var clearButton =
      app.querySelector('#dyFaqClear');

    var countBox =
      app.querySelector('#dyFaqCount');

    var categoryLabel =
      app.querySelector(
        '#dyFaqCategoryLabel'
      );

    var noResults =
      app.querySelector(
        '#dyFaqNoResults'
      );


    var buttons =
      Array.prototype.slice.call(
        app.querySelectorAll(
          '.dy-category-btn'
        )
      );


    var faqItems =
      Array.prototype.slice.call(
        app.querySelectorAll(
          '.dy-faq-item'
        )
      );


    if (
      !searchInput ||
      !buttons.length ||
      !faqItems.length
    ) {
      console.error(
        'DYENOTE FAQ V4: gerekli elemanlar bulunamadı.'
      );

      return;
    }


    app.setAttribute(
      'data-dyenote-faq-v4',
      'ready'
    );


    var activeCategory = 'all';


    /* =====================================================
       HER FAQ İÇİN KATEGORİ CACHE OLUŞTUR
    ===================================================== */

    faqItems.forEach(function (item) {
      var categories =
        getItemCategories(item);


      /*
        data-category tanınmadıysa
        metinden kategori çıkar.
      */

      if (!categories.length) {
        categories =
          inferCategoryFromContent(item);
      }


      item._dyenoteCategories =
        categories;
    });


    /* =====================================================
       GÖSTER / GİZLE
    ===================================================== */

    function setVisible(
      item,
      visible
    ) {

      if (visible) {

        item.style.removeProperty(
          'display'
        );

        item.removeAttribute(
          'hidden'
        );

      } else {

        item.style.setProperty(
          'display',
          'none',
          'important'
        );

        item.setAttribute(
          'hidden',
          ''
        );

        item.open = false;
      }
    }


    /* =====================================================
       AKTİF KATEGORİ ETİKETİ
    ===================================================== */

    function updateCategoryLabel() {
      if (!categoryLabel) {
        return;
      }


      var activeButton =
        app.querySelector(
          '.dy-category-btn.active'
        );


      if (
        !activeButton ||
        activeCategory === 'all'
      ) {

        categoryLabel.textContent =
          'Tüm kategoriler';

        return;
      }


      categoryLabel.textContent =
        activeButton.textContent.trim();
    }


    /* =====================================================
       FİLTRE
    ===================================================== */

    function filterFAQ() {
      var query =
        normalizeText(
          searchInput.value
        );

      var visibleCount = 0;


      faqItems.forEach(function (item) {

        var categories =
          item._dyenoteCategories ||
          [];


        var categoryMatches =
          activeCategory === 'all' ||
          categories.indexOf(
            activeCategory
          ) !== -1;


        var searchMatches =
          query === '' ||
          normalizeText(
            item.textContent
          ).indexOf(query) !== -1;


        var visible =
          categoryMatches &&
          searchMatches;


        setVisible(
          item,
          visible
        );


        if (visible) {
          visibleCount++;
        }
      });


      /* SAYI */
      if (countBox) {

        if (visibleCount === 0) {

          countBox.textContent =
            'Sonuç bulunamadı';

        } else if (
          visibleCount === 1
        ) {

          countBox.textContent =
            '1 soru gösteriliyor';

        } else {

          countBox.textContent =
            visibleCount +
            ' soru gösteriliyor';
        }
      }


      /* NO RESULTS */
      if (noResults) {

        noResults.style.display =
          visibleCount === 0
            ? 'block'
            : 'none';
      }


      /* TEMİZLE */
      if (clearButton) {

        clearButton.style.display =
          searchInput.value.trim()
            ? ''
            : 'none';
      }


      updateCategoryLabel();


      console.log(
        'DYENOTE FAQ V4:',
        activeCategory,
        visibleCount + ' sonuç'
      );
    }


    /* =====================================================
       KATEGORİ SEÇ
    ===================================================== */

    function activateCategory(
      button
    ) {

      buttons.forEach(
        function (btn) {

          btn.classList.remove(
            'active'
          );

          btn.setAttribute(
            'aria-pressed',
            'false'
          );
        }
      );


      button.classList.add(
        'active'
      );

      button.setAttribute(
        'aria-pressed',
        'true'
      );


      activeCategory =
        getButtonCategory(
          button
        );


      /*
        Kategori tıklanınca eski
        arama kategoriyi etkilemesin.
      */

      searchInput.value = '';


      if (clearButton) {

        clearButton.style.display =
          'none';
      }


      filterFAQ();
    }


    /* =====================================================
       BUTON EVENTLERİ
    ===================================================== */

    buttons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            activateCategory(
              button
            );
          }
        );
      }
    );


    /* =====================================================
       ARAMA
    ===================================================== */

    searchInput.addEventListener(
      'input',
      function () {

        /*
          Arama bütün kategorilerde yapılır.
        */

        if (
          searchInput.value.trim()
        ) {

          activeCategory =
            'all';


          buttons.forEach(
            function (button) {

              if (
                getButtonCategory(
                  button
                ) === 'all'
              ) {

                button.classList.add(
                  'active'
                );

                button.setAttribute(
                  'aria-pressed',
                  'true'
                );

              } else {

                button.classList.remove(
                  'active'
                );

                button.setAttribute(
                  'aria-pressed',
                  'false'
                );
              }
            }
          );
        }


        filterFAQ();
      }
    );


    searchInput.addEventListener(
      'search',
      filterFAQ
    );


    /* =====================================================
       TEMİZLE
    ===================================================== */

    if (clearButton) {

      clearButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          searchInput.value = '';

          activeCategory = 'all';


          buttons.forEach(
            function (button) {

              if (
                getButtonCategory(
                  button
                ) === 'all'
              ) {

                button.classList.add(
                  'active'
                );

              } else {

                button.classList.remove(
                  'active'
                );
              }
            }
          );


          filterFAQ();

          searchInput.focus();
        }
      );
    }


    /* =====================================================
       ESC
    ===================================================== */

    searchInput.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape'
        ) {

          searchInput.value = '';

          activeCategory =
            'all';


          buttons.forEach(
            function (button) {

              if (
                getButtonCategory(
                  button
                ) === 'all'
              ) {

                button.classList.add(
                  'active'
                );

              } else {

                button.classList.remove(
                  'active'
                );
              }
            }
          );


          filterFAQ();
        }
      }
    );


    /* =====================================================
       ACCORDION
    ===================================================== */

    faqItems.forEach(
      function (item) {

        item.addEventListener(
          'toggle',
          function () {

            if (!item.open) {
              return;
            }


            faqItems.forEach(
              function (other) {

                if (
                  other !== item &&
                  other.open
                ) {

                  other.open =
                    false;
                }
              }
            );
          }
        );
      }
    );


    /* =====================================================
       BAŞLANGIÇ
    ===================================================== */

    filterFAQ();


    console.log(
      'DYENOTE FAQ V4 AKTİF:',
      buttons.length,
      'kategori /',
      faqItems.length,
      'soru'
    );
  }


  /* =========================================================
     BOOT
  ========================================================= */

  function boot() {
    setTimeout(
      initDyenoteFAQ,
      50
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();
  }


  window.addEventListener(
    'load',
    function () {

      setTimeout(
        initDyenoteFAQ,
        100
      );
    }
  );


  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    function () {

      var app =
        document.getElementById(
          'dyenoteFaqApp'
        );


      if (app) {

        app.removeAttribute(
          'data-dyenote-faq-v4'
        );
      }


      setTimeout(
        initDyenoteFAQ,
        100
      );
    }
  );

})();